import React from 'react';
import SequencesPage from './SequencesPage';
import SequencesContextProvider, {
	useSequencesContext
} from '../SequencesContext';
import SequenceStartPage from './SequenceStartPage';
import SequenceStepCreationPage from './SequenceStepCreationPage';
import SequenceAddBusinessPage from './SequenceAddBusinessPage';
import SequencesSendAll from './SequencesSendAll';

export default function Sequences() {
	return (
		<SequencesContextProvider>
			<SequencePageSelector />
		</SequencesContextProvider>
	);
}

function SequencePageSelector() {
	const { sequencePage, showSendAll } = useSequencesContext();

	return (
		<div className="h-full w-full p-5">
			{sequencePage === 'MY-SEQUENCES' && <SequencesPage />}
			{sequencePage === 'SEQUENCE-START' && <SequenceStartPage />}
			{sequencePage === 'STEPS-CREATION' && <SequenceStepCreationPage />}
			{sequencePage === 'ADD-BUSINESS' && <SequenceAddBusinessPage />}
			{showSendAll && <SequencesSendAll />}
		</div>
	);
}
